import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';

import { SicherungssystemModel, SicherungssystemModelView, SicherungssystemModelService, ProjectLanguage, SysLandService, RoofareaService, RoofareaModel, RoofareaViewService, RoofareaModelView, DebitorModelView, StandortModelView, ObjektModelView, DebitorViewService, ObjektViewService, StandortViewService, ProjektPermissionService } from '../../../public-api';
import { CreateStandortComponent } from '../create-standort/create-standort.component';
import { CreateObjektComponent } from '../create-objekt/create-objekt.component';
import { CreateRoofareaComponent } from '../create-roofarea/create-roofarea.component';

@Component({
  selector: 'app-create-sicherungssystem',
  templateUrl: './create-sicherungssystem.component.html',
  styleUrls: ['./create-sicherungssystem.component.scss'],
  standalone: false
})
export class CreateSicherungssystemComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public sicherungssystem: SicherungssystemModel | null = null;

  public debitorList: DebitorModelView[] = [];
  public standortList: StandortModelView[] = [];
  public selectedstandortModelView: StandortModelView | null = null;

  public objektList: ObjektModelView[] = [];
  public selectedobjektModelView: ObjektModelView | null = null;


  public roofareaList: RoofareaModelView[] = [];

  private DebitorControl: FormControl<DebitorModelView | null> = new FormControl<DebitorModelView | null>(null, [Validators.required]);
  private StandortControl: FormControl<StandortModelView | null> = new FormControl<StandortModelView | null>(null, [Validators.required]);
  private ObjektControl: FormControl<ObjektModelView | null> = new FormControl<ObjektModelView | null>(null, [Validators.required]);

  private RoofareaControl: FormControl<RoofareaModelView | null> = new FormControl<RoofareaModelView | null>(null, [Validators.required]);
  private BezeichnungControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(100)]);

  public FormGroup = new UntypedFormGroup({
    debitorControl: this.DebitorControl,
    standortControl: this.StandortControl,
    objektControl: this.ObjektControl,

    roofareaControl: this.RoofareaControl,

    bezeichnungControl: this.BezeichnungControl
  });
  //#endregion

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<SicherungssystemModelView>,
    public dialogRef: MatDialogRef<CreateSicherungssystemComponent>,
    public debitorService: DebitorViewService,
    public standortViewService: StandortViewService,
    public objektService: ObjektViewService,
    public sicherungssystemService: SicherungssystemModelService,
    public roofareaViewService: RoofareaViewService,
    public syslandService: SysLandService,
    private dialog: MatDialog,
    public permissionService: ProjektPermissionService,
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;
    this.debitorList= await this.debitorService.getList(),
    this.standortList= await this.standortViewService.getList(),
    this.objektList = await this.objektService.getList();
    this.roofareaList = await this.roofareaViewService.getList();
    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.Sicherungssystemerstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.Sicherungssystembearbeiten);
    }

    if(!this.data.data?.SicherungssystemID && this.data.data?.DebitorID){
        this.debitorList = this.debitorList.filter(x=>x.DebitorID == this.data.data?.DebitorID)
    }
    if(!this.data.data?.SicherungssystemID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID == this.data.data?.StandortID)
    }
    if(!this.data.data?.SicherungssystemID && this.data.data?.ObjektID){
        this.objektList = this.objektList.filter(x=>x.ObjektID == this.data.data?.ObjektID)
    }

    if (!this.data.data?.SicherungssystemID && this.data.data?.RoofareaID) {
      this.roofareaList = this.roofareaList.filter(x => x.RoofareaID == this.data.data?.RoofareaID);
    }

    if (this.data.data?.SicherungssystemID) {

      this.sicherungssystem = await this.sicherungssystemService.get(this.data.data.SicherungssystemID);
      this.BezeichnungControl.setValue(this.sicherungssystem?.Bezeichnung!);
      this.RoofareaControl.setValue(this.roofareaList.find(x => x.RoofareaID == this.sicherungssystem?.RoofareaID)!);
    }
    else {
      this.sicherungssystem = {} as SicherungssystemModel;
      if(!this.data.data?.SicherungssystemID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID==this.data.data?.StandortID)
        this.StandortControl.setValue(this.standortList[0]) ;
      }
      if(!this.data.data?.SicherungssystemID && this.data.data?.ObjektID){
        this.objektList = this.objektList.filter(x=>x.ObjektID==this.data.data?.ObjektID)
        this.ObjektControl.setValue(this.objektList[0]) ;
      }
      if(!this.data.data?.SicherungssystemID && this.data.data?.RoofareaID){
        this.roofareaList = this.roofareaList.filter(x=>x.RoofareaID==this.data.data?.RoofareaID)
        this.RoofareaControl.setValue(this.roofareaList[0]) ;
      }
    }
    this.loading = false;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (this.FormGroup.valid) {

      this.loading = true;
      this.sicherungssystem = new SicherungssystemModel();

      if (this.data.mode == 'edit' && this.data.data) {
        this.sicherungssystem.SicherungssystemID = this.data.data?.SicherungssystemID!;
      }

      this.sicherungssystem.RoofareaID = this.RoofareaControl.value?.RoofareaID!;
      this.sicherungssystem.Bezeichnung = this.BezeichnungControl.value!;
      if (this.sicherungssystem.SicherungssystemID > 0)       //Update
        var Item = await this.sicherungssystemService.put(this.sicherungssystem.SicherungssystemID, this.sicherungssystem)
      else                                  // Insert
        var Item = await this.sicherungssystemService.post(this.sicherungssystem)

      this.loading = false;
      this.dialogRef.close(Item);
    }
  }

  public Abbrechen() {
    this.dialogRef.close();
  }

  getfilterStandortList() {
    if (!this.DebitorControl.value?.DebitorID) return [];
    return this.standortList.filter(x => x.DebitorID == this.DebitorControl.value?.DebitorID);
  }
  public OpenCreateStandortDialog = (): Promise<StandortModelView> => {
    return new Promise<StandortModelView>((resolve, reject) => {

      var StandortModelView: StandortModelView = {
        StandortID: 0,
        DebitorID: this.DebitorControl.value?.DebitorID!,
        Strasse: "",
        PLZ: "",
        Ort: "",
        LandID: null,
        Bezeichnung: ""
      }

      var data = new DialogData(StandortModelView, 'create');
      this.dialog.open(CreateStandortComponent, { data: data }).afterClosed().subscribe((item: StandortModelView) => {
        if (item) {
          this.standortList.push(item);
        }

        resolve(item);
      });

    });
  }

  getfilterObjektList() {
    if (!this.StandortControl.value?.StandortID) return [];
    return this.objektList.filter(x => x.StandortID == this.StandortControl.value?.StandortID);
  }

  public OpenCreateObjektDialog = (): Promise<ObjektModelView> => {
    return new Promise<ObjektModelView>((resolve, reject) => {

      var ObjektModelView: ObjektModelView = {
        StandortID: this.StandortControl.value?.StandortID!,
        Strasse: "",
        PLZ: "",
        Ort: "",
        Bezeichnung: ""
      }

      var data = new DialogData(ObjektModelView, 'create');
      this.dialog.open(CreateObjektComponent, { data: data }).afterClosed().subscribe((item: ObjektModelView) => {
        if (item) {
          this.objektList.push(item);
        }

        resolve(item);
      });

    });
  }

  getfilterRoofareaList() {
    if (!this.ObjektControl.value?.ObjektID) return [];
    return this.roofareaList.filter(x => x.ObjektID == this.ObjektControl.value?.ObjektID);
  }

  public OpenCreateRoofareaDialog = (): Promise<RoofareaModelView> => {
    return new Promise<RoofareaModelView>((resolve, reject) => {

      var RoofareaModelView: RoofareaModelView = {
        RoofareaID:0,
        ObjektID: this.ObjektControl.value?.ObjektID!,
        Bezeichnung: ""
        
      }

      var data = new DialogData(RoofareaModelView, 'create');
      this.dialog.open(CreateRoofareaComponent, { data: data }).afterClosed().subscribe((item: RoofareaModelView) => {
        if (item) {
          this.roofareaList.push(item);
        }

        resolve(item);
      });

    });
  }
}
